/* ============================================================
   PurpleGreens® Fußnoten-Engine
   Datei: pg-footnotes.js
   Version: 1.1 — 19.10.2026
   
   Syntax im Rich-Text-Editor:
     [fn:1]           → hochgestellte ¹
     [fn:1,3,15]      → ¹·³·¹⁵
     [fn:nrv]         → hochgestelltes *  (Sonderzeichen-Fußnote)
     [fn:made]        → hochgestelltes ˟  
     [fn:nem]         → hochgestelltes ˟˟ 
     [fn:review]      → hochgestelltes ˟˟˟
   
   Am Seitenende wird automatisch ein Fußnotenblock generiert,
   der nur die tatsächlich verwendeten Fußnoten enthält.

   Änderungen 1.1:
   - Kein Abbruch mehr, wenn pg-footnotes-data.js fehlt oder
     später geladen wird (Zugriff abgesichert, Warte-Logik)
   - Jeder Textknoten wird einzeln abgesichert verarbeitet
   - Zusätzlicher Durchlauf nach window.load als Fallback
   - Diagnose-Ausgabe in der Konsole (Anzahl ersetzter Marker)
   ============================================================ */

(function() {
  'use strict';

  // ============================================================
  // KONFIG
  // ============================================================
  
  var FN_REGEX = /\[fn:\s*([a-z0-9, ]+?)\s*\]/gi;
  var SKIP_TAGS = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'CODE', 'PRE', 'BUTTON'];

  // Wie lange auf pg-footnotes-data.js gewartet wird (ms)
  var DATA_WAIT_MAX = 4000;
  var DATA_WAIT_STEP = 100;

  // Symbol-Mapping für Sonderzeichen-Fußnoten
  var SYMBOL_DISPLAY = {
    "nrv":    "*",
    "made":   "˟",
    "nem":    "˟˟",
    "review": "˟˟˟"
  };

  // Reihenfolge im Footnote-Block
  var SYMBOL_ORDER = ["nrv", "made", "nem", "review"];

  // Hochgestellt wird via CSS gemacht (.pg-fn-ref), nicht via Unicode-Glyphs.
  function toSuper(num) {
    return String(num);
  }

  // Abgesicherter Zugriff auf die Datendateien
  function getData() {
    return (window.PGFootnotesData && typeof window.PGFootnotesData === 'object') ? window.PGFootnotesData : null;
  }
  function getSymbols() {
    return (window.PGFootnotesSymbols && typeof window.PGFootnotesSymbols === 'object') ? window.PGFootnotesSymbols : {};
  }
  function isKnownKey(key) {
    if (SYMBOL_DISPLAY.hasOwnProperty(key)) return true;
    var data = getData();
    return !!(data && data[key]);
  }

  // ============================================================
  // TEIL 1: AUTO-REPLACE [fn:N] in hochgestellte Links
  // ============================================================

  // Globaler Tracker: welche Fußnoten kommen auf dieser Seite vor?
  var seenKeys = [];           // Reihenfolge des ersten Vorkommens
  var seenKeysSet = {};        // Lookup
  var refCounter = {};         // Zähler für back-refs pro Schlüssel
  var refMap = {};             // key → Array von Anker-IDs
  var replacedCount = 0;       // Diagnose

  function registerKey(key) {
    if (!seenKeysSet[key]) {
      seenKeysSet[key] = true;
      seenKeys.push(key);
      refCounter[key] = 0;
      refMap[key] = [];
    }
  }

  function buildSingleAnchor(key) {
    registerKey(key);
    refCounter[key]++;
    var refId = 'pg-fnref-' + key + '-' + refCounter[key];
    refMap[key].push(refId);
    var isSymbol = SYMBOL_DISPLAY.hasOwnProperty(key);
    var display = isSymbol ? SYMBOL_DISPLAY[key] : toSuper(key);
    return '<a id="' + refId + '" href="#pg-fn-' + key + '" data-pg-fn="' + key + '">' + display + '</a>';
  }

  function buildMultiFootnoteHTML(keysStr) {
    // [fn:1,3,15] → mehrere Fußnoten mit Mittelpunkt-Separator
    var keys = keysStr.split(',').map(function(k) { return k.trim().toLowerCase(); }).filter(Boolean);
    var parts = [];
    var unknown = [];

    keys.forEach(function(key) {
      if (!isKnownKey(key)) {
        unknown.push(key);
        return;
      }
      parts.push(buildSingleAnchor(key));
    });

    if (unknown.length) {
      console.warn('[PG-Footnotes] Unbekannte Fußnote(n):', unknown.join(', '));
    }

    // Keine einzige gültige Fußnote → Marker unverändert lassen
    if (parts.length === 0) {
      return '[fn:' + keysStr + ']';
    }

    replacedCount++;

    if (parts.length === 1) {
      return '<sup class="pg-fn-ref">' + parts[0] + '</sup>';
    }
    return '<sup class="pg-fn-ref pg-fn-multi">' + parts.join('<span class="pg-fn-sep">·</span>') + '</sup>';
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function processTextNode(textNode) {
    var text = textNode.nodeValue;
    if (!text || text.indexOf('[fn:') === -1) return false;
    if (!textNode.parentNode) return false;

    FN_REGEX.lastIndex = 0;
    if (!FN_REGEX.test(text)) return false;

    FN_REGEX.lastIndex = 0;
    var newHTML = '';
    var lastIndex = 0;
    var match;
    var replaced = false;

    while ((match = FN_REGEX.exec(text)) !== null) {
      newHTML += escapeHtml(text.substring(lastIndex, match.index));
      newHTML += buildMultiFootnoteHTML(match[1]);
      lastIndex = FN_REGEX.lastIndex;
      replaced = true;
    }
    if (!replaced) return false;
    
    newHTML += escapeHtml(text.substring(lastIndex));

    var wrapper = document.createElement('span');
    wrapper.className = 'pg-footnote-wrapper';
    wrapper.innerHTML = newHTML;
    textNode.parentNode.replaceChild(wrapper, textNode);
    return true;
  }

  function walkAndReplace(root) {
    if (!root) return;
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          if (!node.nodeValue || node.nodeValue.indexOf('[fn:') === -1) {
            return NodeFilter.FILTER_REJECT;
          }
          var parent = node.parentNode;
          while (parent && parent !== root) {
            if (SKIP_TAGS.indexOf(parent.tagName) !== -1) return NodeFilter.FILTER_REJECT;
            if (parent.classList && (parent.classList.contains('pg-footnote-wrapper') || parent.classList.contains('pg-footnotes-block'))) {
              return NodeFilter.FILTER_REJECT;
            }
            parent = parent.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );
    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);

    // Jeden Knoten einzeln absichern: ein Fehler darf nicht alle anderen blockieren
    nodes.forEach(function(node) {
      try {
        processTextNode(node);
      } catch (err) {
        console.error('[PG-Footnotes] Fehler beim Ersetzen eines Markers:', err, node.nodeValue);
      }
    });
  }

  // Bereits ersetzte Marker einsammeln (für erneuten Durchlauf nach Load),
  // damit Zähler und Fußnotenblock vollständig bleiben
  function collectExistingRefs(root) {
    var anchors = (root || document).querySelectorAll('.pg-footnote-wrapper a[data-pg-fn]');
    Array.prototype.forEach.call(anchors, function(a) {
      var key = a.getAttribute('data-pg-fn');
      if (!key) return;
      registerKey(key);
      refCounter[key]++;
      refMap[key].push(a.id);
    });
  }

  // ============================================================
  // TEIL 2: FUSSNOTENBLOCK AM SEITENENDE RENDERN
  // ============================================================

  function renderFootnoteBlock() {
    if (seenKeys.length === 0) {
      // Nichts gefunden → existierenden Block ggf. entfernen
      var old = document.getElementById('pg-footnotes-block');
      if (old) old.remove();
      return;
    }

    var data = getData() || {};
    var symbols = getSymbols();

    // Sortierung: zuerst numerische Fußnoten, dann Symbol-Fußnoten in fixer Reihenfolge
    var numericKeys = seenKeys.filter(function(k) { return !SYMBOL_DISPLAY[k]; });
    var symbolKeys = SYMBOL_ORDER.filter(function(k) { return seenKeysSet[k]; });
    
    numericKeys.sort(function(a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    
    var orderedKeys = numericKeys.concat(symbolKeys);

    var existing = document.getElementById('pg-footnotes-block');
    if (existing) existing.remove();

    var block = document.createElement('section');
    block.id = 'pg-footnotes-block';
    block.className = 'pg-footnotes-block';
    block.setAttribute('aria-label', 'Fußnoten und Health Claims');

    var details = document.createElement('details');
    details.className = 'pg-footnotes-details';

    var summary = document.createElement('summary');
    summary.className = 'pg-footnotes-summary';
    summary.innerHTML = 'Fußnoten & Health Claims';
    details.appendChild(summary);

    var list = document.createElement('ol');
    list.className = 'pg-footnotes-list';

    orderedKeys.forEach(function(key) {
      var isSymbol = SYMBOL_DISPLAY.hasOwnProperty(key);
      var text = isSymbol ? symbols[key] : data[key];
      if (!text) return;
      var marker = isSymbol ? SYMBOL_DISPLAY[key] : toSuper(key);
      
      var item = document.createElement('li');
      item.className = 'pg-footnotes-item';
      item.id = 'pg-fn-' + key;
      
      var backref = '';
      if (refMap[key] && refMap[key].length) {
        backref = '<a class="pg-fn-back" href="#' + refMap[key][0] + '" aria-label="Zurück zum Text">↩</a>';
      }
      
      item.innerHTML = '<span class="pg-fn-marker">' + marker + '</span> <span class="pg-fn-text">' + escapeHtml(String(text)) + '</span> ' + backref;
      list.appendChild(item);
    });

    details.appendChild(list);
    block.appendChild(details);

    var insertionPoint = document.querySelector('[data-pg-footnotes]');
    if (insertionPoint) {
      insertionPoint.appendChild(block);
    } else {
      var main = document.querySelector('main, #main, [role="main"]');
      if (main) {
        main.appendChild(block);
      } else {
        document.body.appendChild(block);
      }
    }
  }

  // ============================================================
  // TEIL 3: SMOOTH-SCROLL UND HIGHLIGHT
  // ============================================================

  var scrollingBound = false;

  function bindFootnoteScrolling() {
    if (scrollingBound) return;
    scrollingBound = true;

    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[data-pg-fn]');
      if (link) {
        e.preventDefault();
        var key = link.getAttribute('data-pg-fn');
        var target = document.getElementById('pg-fn-' + key);
        if (target) {
          var details = target.closest('details');
          if (details && !details.open) details.open = true;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.classList.add('is-highlighted');
          setTimeout(function() { target.classList.remove('is-highlighted'); }, 1800);
        }
        return;
      }
      var back = e.target.closest('.pg-fn-back');
      if (back) {
        e.preventDefault();
        var href = back.getAttribute('href');
        var anchor = document.querySelector(href);
        if (anchor) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var sup = anchor.closest('.pg-fn-ref');
          if (sup) {
            sup.classList.add('is-highlighted');
            setTimeout(function() { sup.classList.remove('is-highlighted'); }, 1800);
          }
        }
      }
    });
  }

  // ============================================================
  // INIT
  // ============================================================

  function init(root) {
    // State zurücksetzen, damit nichts doppelt zählt
    seenKeys = [];
    seenKeysSet = {};
    refCounter = {};
    refMap = {};
    replacedCount = 0;

    if (!getData()) {
      console.error('[PG-Footnotes] window.PGFootnotesData nicht gefunden – wird pg-footnotes-data.js vor pg-footnotes.js geladen?');
    }

    var scope = root || document.body;
    collectExistingRefs(scope);
    walkAndReplace(scope);
    renderFootnoteBlock();

    console.info('[PG-Footnotes] Durchlauf abgeschlossen: ' + replacedCount + ' Marker ersetzt, ' + seenKeys.length + ' Fußnoten auf der Seite.');
  }

  // Wartet, bis pg-footnotes-data.js verfügbar ist, dann init()
  function initWhenReady() {
    var waited = 0;
    (function tick() {
      if (getData() || waited >= DATA_WAIT_MAX) {
        init();
        bindFootnoteScrolling();
        return;
      }
      waited += DATA_WAIT_STEP;
      setTimeout(tick, DATA_WAIT_STEP);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }

  // Fallback: Inhalte, die erst nach DOMContentLoaded ins DOM kommen
  window.addEventListener('load', function() {
    setTimeout(function() {
      if (document.body && document.body.textContent.indexOf('[fn:') !== -1) {
        init();
      }
    }, 300);
  });

  document.addEventListener('shopify:section:load', function() { setTimeout(init, 50); });
  document.addEventListener('shopify:section:reorder', function() { init(); });

  window.PGFootnotes = { init: init };

})();